<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
*{
  margin: 0;
  padding: 0;
}
html,body{
  width: 100%;
  height: 100%;
  font-size: 14px;
  scroll-behavior: smooth;  
}

.dark{
    background-color: black;
    color: #fff;
}

#modeBtn:hover{
  cursor: pointer;
}

#modeBtn::after {
  content: '🌞';
}
body.dark #modeBtn::after {
  content: '🌜';
}

@media screen and (max-width: 768px) {
  html,body{
    font-size: 12px;
  }
  .project-item-left{
    width: 100% !important;
  }
  .project-item-right{
    display: none;
  }
  .my-experience {
    .experience-box{
      padding-bottom: 4.5rem !important;
      .experience-item{
        flex-direction: column-reverse;
        .experience-item-left{
          width: 100% !important;
        }
        .experience-item-right{
          padding-left: 1rem !important;
          margin-bottom: .5rem;
        }
      }
      .ex-line{
        left:0 !important;
      }
      .pos-img{
        left:0 !important;
      }
    }
  }
}
@media screen and (max-width: 414px) {
  html,body{
    font-size: 11px;
  }
  .project-item-left{
    width: 100% !important;
  }
  .project-item-right{
    display: none;
  }
  .my-experience {
    .experience-box{
      padding-bottom: 4.5rem !important;
      .experience-item{
        flex-direction: column-reverse;
        .experience-item-left{
          width: 100% !important;
        }
        .experience-item-right{
          padding-left: 1rem !important;
          margin-bottom: .5rem;
        }
      }
      .ex-line{
        left:0 !important;
      }
      .pos-img{
        left:0 !important;
      }
    }
  }
}
@media screen and (max-width: 375px) {
  html,body{
    font-size: 10px;
  }
  .project-item-left{
    width: 100% !important;
  }
  .project-item-right{
    display: none;
  }
  .my-experience {
    .experience-box{
      padding-bottom: 4.5rem !important;
      .experience-item{
        flex-direction: column-reverse;
        .experience-item-left{
          width: 100% !important;
        }
        .experience-item-right{
          padding-left: 1rem !important;
          margin-bottom: .5rem;
        }
      }
      .ex-line{
        left:0 !important;
      }
      
      .pos-img{
        left:0 !important;
      }
    }
  }
}
@media screen and (max-width: 320px) {
  html,body{
    font-size: 9px;
  }
  .project-item-left{
    width: 100% !important;
  }
  .project-item-right{
    display: none;
  }
  .my-experience {
    .experience-box{
      padding-bottom: 4.5rem !important;
      .experience-item{
        flex-direction: column-reverse;
        .experience-item-left{
          width: 100% !important;
        }
        .experience-item-right{
          padding-left: 1rem !important;
          margin-bottom: .5rem;
        }
      }
      .ex-line{
        left:0 !important;
      }
      .pos-img{
        left:0 !important;
      }
    }
  }
}
a{
  text-decoration: none;
}
ul li{
  list-style: none;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--theme-default-color);
  height: 100%;
  background-color: var(--theme-all-bacg);
}
</style>



// WEBPACK FOOTER //
// src/App.vue